import { Wrapper } from 'AppReact';
import styled, { css, keyframes } from 'styled-components';

export const grow = (left, top) => keyframes`
  0% {
    width: 0px;
    height: 0px;
    overflow: hidden;
    left: 50%;
    top: 50%;
  }
  99% {
    overflow: hidden;
    width: 162px;
    height: 102px;
    left: ${left};
    top: ${top};
  }
  100% {
    overflow: unset;
  }
`;

const template = styled.div`
  ${({ displayState }) => css`
    position: absolute;
    left: ${displayState?.left ?? '0px'};
    top: ${displayState?.top ?? '0px'};
    z-index: 10;
    animation: ${grow(displayState?.left, displayState.top)} 500ms ease-in-out 0s forwards;;  
  `}
`;

export default Wrapper(template);